/* eslint-disable @typescript-eslint/no-unused-vars */

import {
    SliceFactory,
    FetchCollectionData,
    FetchItemDataType,
    ApiCollectionResponse,
} from '@europrocurement/l2d-redux-utils';
import {
    ConfigurationParameters as DossiersConfigurationParameters,
    Configuration,
    DossierApiApiDossiersIdGetRequest,
    CollectionDeDossierJsonldCollectiondossierRead,
    CollectionDeDossierApi,
    CollectionDeDossierApiApiCollectionsDossiersGetCollectionRequest,
} from '../../../openApi/ApiFormalite';
import { ORDERS_SLICE_NAME, FORMALITES_REDUCER_NAME } from '../constants';

export type OrderApiObject = CollectionDeDossierJsonldCollectiondossierRead;

export type Order = OrderApiObject;

export const additionalOrdersDataSources: Array<string> = [];

export const mapperOrders = function (order: Order) {
    return {
        ...order,
    } as Order;
};

export function createOrderSlice(configuration: DossiersConfigurationParameters) {
    const conf = new Configuration(configuration);
    const api = new CollectionDeDossierApi(conf);

    const fetchOrdersCollection: FetchCollectionData<Order> = ({
        search,
        pagination,
        filters,
        orders,
        xIdSociete,
        rootstate,
    }) => {
        const options = undefined;

        let clientId: number | undefined;
        let clientId2: Array<number> | undefined;
        let dossiersNumero: string | undefined;
        let libelle: string | undefined;
        let numero: string | undefined;
        let prescripteurId: number | undefined;
        let prescripteurId2: Array<number> | undefined;
        let societeId: number | undefined;
        let societeId2: Array<number> | undefined;
        let statutId: number | undefined;
        let statutId2: Array<number> | undefined;

        if (filters.clientId) {
            clientId = filters.clientId as number;
        }

        if (filters.clientId2) {
            clientId2 = filters.clientId2 as Array<number>;
        }

        if (filters.dossiersNumero) {
            dossiersNumero = filters.dossiersNumero as string;
        }

        if (filters.libelle) {
            libelle = filters.libelle as string;
        }

        if (filters.numero) {
            numero = filters.numero as string;
        }

        if (filters.prescripteurId) {
            prescripteurId = filters.prescripteurId as number;
        }

        if (filters.prescripteurId2) {
            prescripteurId2 = filters.prescripteurId2 as Array<number>;
        }

        if (filters.societeId) {
            societeId = filters.societeId as number;
        }

        if (filters.societeId2) {
            societeId2 = filters.societeId2 as Array<number>;
        }

        if (filters.statutId) {
            statutId = filters.statutId as number;
        }

        if (filters.statutId2) {
            statutId2 = filters.statutId2 as Array<number>;
        }

        if (search && search !== '') {
            numero = search;
        }

        const requestParameters: CollectionDeDossierApiApiCollectionsDossiersGetCollectionRequest =
            {
                page: pagination.page + 1,
                itemsPerPage: pagination.itemsPerPage,
                clientId,
                clientId2,
                dossiersNumero,
                libelle,
                numero,
                prescripteurId,
                prescripteurId2,
                societeId,
                societeId2,
                statutId,
                statutId2,
            };

        return api
            .apiCollectionsDossiersGetCollection(requestParameters, options)
            .then((res) => res.data) as Promise<ApiCollectionResponse<Order>>;
    };

    const fetchOrderItem: FetchItemDataType<Order> = ({
        idItem,
        search,
        pagination,
        filters,
        orders,
        xIdSociete,
        rootstate,
    }) => {
        const requestParameters: DossierApiApiDossiersIdGetRequest = {
            id: String(idItem),
        };

        return api
            .apiCollectionsDossiersIdGet(requestParameters)
            .then((res) => res.data) as Promise<Order>;
    };

    const { slice: orderSlice, dataSourcesThunks: orderDataSourcesThunks } =
        SliceFactory.createSlice<Order, Order>(
            ORDERS_SLICE_NAME,
            FORMALITES_REDUCER_NAME,
            additionalOrdersDataSources,
            fetchOrdersCollection,
            fetchOrderItem,
            mapperOrders,
            {},
            {},
        );

    return { orderSlice, orderDataSourcesThunks };
}
